import React, { useEffect, useRef } from "react";
import styles from "./UndoToast.module.css";
import { motion, useAnimation } from "framer-motion";

import { tr } from '@/i18n';
interface ToastProps {
  message: string;
  onUndo: () => void;
  onDismiss: () => void;
  duration?: number;
}

export const UndoToast: React.FC<ToastProps> = ({
  message,
  onUndo,
  onDismiss,
  duration = 5000, // Уменьшил время для удобства отладки
}) => {
  const controls = useAnimation();
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss; // Всегда храним последнюю версию функции

  useEffect(() => {
    controls.start({
      strokeDashoffset: 100,
      transition: { duration: duration / 1000, ease: "linear" },
    });

    const timer = setTimeout(() => {
      // Вызываем последнюю версию onDismiss
      onDismissRef.current();
    }, duration);

    return () => clearTimeout(timer);
  }, [controls, duration]);

  return (
    <motion.div
      className={styles.toast}
      initial={{ opacity: 0, y: 30, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 10, scale: 0.9, transition: { duration: 0.2 } }}
    >
      <div className={styles.toastContent}>
        <span className={styles.toastText}>{message}</span>
        <button className={styles.toastButton} onClick={onUndo}>
          {tr("ui.undo", "Undo")}
        </button>

        <svg className={styles.circleTimer} viewBox="0 0 36 36">
          <circle className={styles.bgCircle} cx="18" cy="18" r="16" />
          <motion.circle
            className={styles.fgCircle}
            cx="18"
            cy="18"
            r="16"
            strokeDasharray="100"
            strokeDashoffset="0"
            animate={controls}
          />
        </svg>
      </div>
    </motion.div>
  );
};